// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_DeletarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento/deletar
 *
 * Deletes a payment method (forma de pagamento).
 */
import { registerContract } from './validate'

export interface FormasPagamento_DeletarInput {
forma_pagamento_id: number
}

registerContract('FormasPagamento_DeletarInput', {
  forma_pagamento_id: { type: 'number',  required: true },
})
